import { render, staticRenderFns } from "./ApprovedClaimDetails.vue?vue&type=template&id=13cc5638&scoped=true"
import script from "./ApprovedClaimDetails.vue?vue&type=script&lang=js"
export * from "./ApprovedClaimDetails.vue?vue&type=script&lang=js"
import style0 from "./ApprovedClaimDetails.vue?vue&type=style&index=0&id=13cc5638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cc5638",
  null
  
)

export default component.exports